module.exports = __webpack_public_path__ + "static/media/12.8714183d.jpg";